import {Injectable} from '@angular/core';
import {environment} from '@Env/environment';
import {DaoGeneric} from '@Services/base/daoService';
import {HttpClient} from '@angular/common/http';
import {StateSubscription, Subscription, SubscriptionCategorieCours} from './subscription.model';
import {Individu} from '@Common/core/services';
import {TypeCours} from '../planning/plannig.model';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService extends DaoGeneric<Subscription> {

  private states: Map<StateSubscription, string> = new Map<StateSubscription, string>([
    [StateSubscription.waiting, 'En attente'],
    [StateSubscription.accepted, 'Définitive'],
    [StateSubscription.refused, 'Refusée'],
    [StateSubscription.canceled, 'Annulée'],
  ]);

  private categoriesCours: Map<SubscriptionCategorieCours, string> = new Map<SubscriptionCategorieCours, string>([
    [SubscriptionCategorieCours.ec_libre, 'EC libre'],
    [SubscriptionCategorieCours.loisir, 'Loisir'],
  ]);

  readonly url = `${environment.baseUrl}/suaps/inscriptions/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  getRootUrl(): string {
    return this.url;
  }
  displayState(state: StateSubscription): string {
    return this.states.get(state) || '';
  }
  displayCategorieCours(categrieCours: SubscriptionCategorieCours, typeCours: TypeCours): string {
    if (typeCours === TypeCours.stage && categrieCours === SubscriptionCategorieCours.ec_libre) {
      return 'Intensif EC';
    }
    return this.categoriesCours.get(categrieCours) || '';
  }
  colorState(subScription: Subscription) {
    if (subScription?.state_subscription === StateSubscription.waiting) {
      return 'darkorange';
    }
    if (subScription?.state_subscription === StateSubscription.accepted) {
      return 'green';
    }
    if (subScription?.state_subscription === StateSubscription.refused) {
      return 'red';
    }
    if (subScription?.state_subscription === StateSubscription.canceled) {
      return '#f3c2b3';
    }
    return 'black';
  }

  getMySubscription(subscriptions: Subscription[], connecte: Individu): Subscription {
    const mySubscription: Subscription = subscriptions.filter(e => e.member === connecte?.username)[0];
    return (mySubscription || <Subscription>{id: 0});
  }
}
